<template>
  <div>
    <div class="AllShowMapToUSer">
      <div v-if="closeBtn1" class="TextRightAllShowMapToUSer">
        <el-scrollbar class="ShowToUserApartments">
          <div class="TopShowBackToPage">
            <h1>مشاوران املاک</h1>

            <div @click="closeBtn" class="ShowIconVsIcon">
              <i class="fas fa-arrow-left" style="font-size: 24px"></i>
            </div>
          </div>

          <div
            style="margin-top: 30px"
            v-if="data_list.length == 0 && isLoading"
            class="apartmentsListContainer"
          >
            <Skeletor
              v-for="(v, i) in 12"
              :key="i"
              class="ChildShowTabToUserCustomer sliderBottm listSkeletor"
              height="128px"
              style="
                background: rgb(163, 219, 213);
                margin-bottom: 24px;
                border-radius: 10px;
              "
            />
          </div>
          <div
            v-show="data_list.length > 0 && !isLoading"
            class="apartmentsListContainer"
          >
            <di
              style="cursor: pointer"
              class="classShowApartmentSow amlakThumb"
              v-for="(v, i) in data_list"
              @click="showPost(v)"
              :key="i"
            >
              <div class="thumbPic">
                <img :src="v.avatar" :alt="v.title" />
              </div>
              <div class="thumbContent">
                <div class="contentHeader">
                  <div class="realStateTitle">
                    {{ v.title }}
                    <div v-if="v.tick_color" class="realStateTick">
                      <VsxIcon
                        iconName="Verify"
                        :size="20"
                        :color="v.tick_color"
                        type="bold"
                      />
                    </div>
                  </div>
                  <div class="realStateRate">
                    <span>{{ v.user_rate }}/5</span>
                    <i class="fa-solid fa-star"></i>
                  </div>
                  <div class="relStateLoc">
                    <div class="locationIcon">
                      <i class="fa-solid fa-location-dot"></i>
                    </div>
                    <div class="locTitle">
                      {{ v.address }}
                    </div>
                  </div>
                  <div class="realStatePhone">
                    <div class="phoneIcon">
                      <i class="fa-solid fa-phone"></i>
                    </div>
                    <div class="phoneTitle">
                      {{ v.contact }}
                    </div>
                  </div>
                </div>
                <div class="contentFooter">
                  <a
                    :href="'tel:' + v.contact"
                    class="footerCallBtn"
                    @click.stop
                  >
                    <div class="callBtnIcon">
                      <i class="fa-solid fa-phone"></i>
                    </div>
                    <div class="callBtnTitle">تماس</div>
                  </a>
                </div>
              </div>
            </di>
          </div>

          <div v-if="data_list.length == 0 && !isLoading" class="ShowToUSer">
            <img src="/img/notfound.png" alt="" />
            <h1>مشاور املاکی یافت نشد</h1>
          </div>
        </el-scrollbar>
      </div>
      <div class="MapLeftAllShowMapToUSer">
        <div class="mapFilters">
          <div class="mepSearchFilter">
            <input
              type="search"
              inputmode="search"
              enterkeyhint="search"
              v-model="fillter.title"
              placeholder="جستجوی مشاور املاک"
              @keyup.enter="load_post('first')"
            />
            <div class="searchBtn" @click="load_post('first')">
              <i class="fas fa-search"></i>
            </div>
          </div>
          <div class="mapSwiperFilter">
            <div class="swiperFilterList">
              <Swiper :slides-per-view="'auto'" :space-between="9">
                <SwiperSlide>
                  <div
                    class="filterThumb"
                    :class="{ selected: fillter.cid == 0 }"
                    @click="selectSlide(0)"
                  >
                    <div class="filterTit">همه</div>
                  </div>
                </SwiperSlide>
                <SwiperSlide
                  v-for="(v, i) in category_list"
                  :key="i"
                  @click="selectSlide(v.id)"
                >
                  <div
                    class="filterThumb"
                    :class="{ selected: fillter.cid == v.id }"
                  >
                    <div class="filterTit" :title="v.title">{{ v.title }}</div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>

        <div v-if="LoadingMap" class="ShowNeshanMapToUserLoading">
          <span class="loader"></span>
        </div>

        <div
          id="map"
          ref="mapContainer"
          style="height: 100vh"
        ></div>
      </div>

      <div @click="OpenMenu" class="ShowClickToSeeMelk amlakBtn">
        نمایش مشاوران املاک
      </div>
    </div>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import L from "leaflet";
import "leaflet.markercluster";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import "@maplibre/maplibre-gl-leaflet";
import { Skeletor } from "vue-skeletor";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";

try {
  if (maplibregl) {
    maplibregl.setRTLTextPlugin(
      "./js/mapbox-gl-rtl-text.js",
      null,
      true,
    );
  }
} catch (_e) {
  console.error(_e)
}

export default {
  name: "amlakMapMapir",
  components: {
    Skeletor,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      map: null,
      windowWidth: window.innerWidth,
      isDarkMode: false,
      LoadingMap: true,
      isBackAction: false,
      showList: false,
      center: { latitude: 36.5482, longitude: 52.6786 },
      filteredProperties: [],
      data_list: [],
      category_list: [],
      fillter: { title: "", cid: 0, per_page: "get" },
      isLoading: true,

      markers: [],
      leafletMarkers: [],
      markerClusterGroup: null,

      lastRequestedCenter: null,
      lastRequestedRadiusKm: null,
      moveDebounceMs: 700,
      moveDistanceThresholdKm: 0.3,
      radiusChangeThresholdRatio: 0.12,
      currentRequestSource: null,
      debouncedMapRequest: null,
      dataPendingCenter: null,
      dataPendingRadiusKm: null,

      initialZoom: 13,
      mapirToken: "",
      mapInitStarted: false,
      mapInitialized: false,
      publicPath: "",
    };
  },
  computed: {
    closeBtn1() {
      return this.$route.query.branches === "active" || this.windowWidth > 1000;
    },
  },
  watch: {
    "$store.state.c_set": {
      handler() {
        if (this.mapInitStarted) return;

        const c_set = this.$store.state.c_set;
        if (!c_set) return;

        const token =
          c_set.map_info?.mapir_key ||
          c_set.mapir_key ||
          "";

        const serviceKey =
          c_set.map_info?.map_service ||
          c_set.map_service ||
          "";

        if (!token && !serviceKey) return;

        this.mapirToken = token;
        this.publicPath = c_set.public_path || this.publicPath || "";
        this.mapInitStarted = true;

        this.$nextTick(() => {
          this.initMapirMap();
        });
      },
      immediate: true,
    },
  },
  methods: {
    mapGetCenter() {
      if (!this.map) return null;
      const c = this.map.getCenter();
      return { lat: c.lat, lng: c.lng };
    },

    mapGetBounds() {
      if (!this.map) return null;
      const b = this.map.getBounds();
      const ne = b.getNorthEast();
      const sw = b.getSouthWest();
      return {
        ne: { lat: ne.lat, lng: ne.lng },
        sw: { lat: sw.lat, lng: sw.lng },
      };
    },

    initMapirMap() {
      if (this.mapInitialized) return;
      try {
        if (!this.$refs.mapContainer) {
          setTimeout(() => this.initMapirMap(), 50);
          return;
        }

        this.map = L.map(this.$refs.mapContainer, {
          center: [this.center.latitude, this.center.longitude],
          zoom: this.initialZoom,
          minZoom: 4,
          maxZoom: 19,
        });

        if (this.mapirToken) {
          L.maplibreGL({
            style:
              "https://map.ir/vector/styles/main/mapir-xyz-style.json?x-api-key=" +
              this.mapirToken,
            transformRequest: (url) => {
              return {
                url: url,
                headers: { "x-api-key": this.mapirToken },
              };
            },
          }).addTo(this.map);
        } else {
          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap contributors",
          }).addTo(this.map);
        }

        this.markerClusterGroup = L.markerClusterGroup({
          chunkedLoading: true,
          maxClusterRadius: 50,
          spiderfyOnMaxZoom: true,
          showCoverageOnHover: true,
          zoomToBoundsOnClick: true,
          disableClusteringAtZoom: 19,
          maxZoom: 19,
          animate: true,
          animateAddingMarkers: true,
          iconCreateFunction: (cluster) => {
            return L.divIcon({
              html: "<div><span>" + cluster.getChildCount() + "</span></div>",
              className: "custom-cluster-marker",
              iconSize: L.point(40, 40),
            });
          },
        });

        this.map.addLayer(this.markerClusterGroup);

        this.map.on("moveend", this.onMapChanged);
        this.map.on("zoomend", this.onMapChanged);

        this.mapInitialized = true;

        this.$nextTick(() => {
          setTimeout(() => {
            try {
              this.map.invalidateSize(true);
              if (this.data_list && this.data_list.length) {
                this.addMarkers();
                this.updateCircle();
              }
            } catch (e) {
              console.log("e", e);
            }
          }, 100);
        });

        setTimeout(() => {
          this.LoadingMap = false;
          const center = this.mapGetCenter();
          if (center) {
            this.dataPendingCenter = center;
            this.dataPendingRadiusKm = this.calculateViewportRadius() / 1000;
            this.requestDataForMap();
          }
        }, 600);
      } catch (error) {
        console.error("Error initializing map.ir map:", error);
        this.LoadingMap = false;
      }
    },

    destroyMap() {
      try {
        if (this.map) {
          this.map.off("moveend", this.onMapChanged);
          this.map.off("zoomend", this.onMapChanged);
          this.map.remove();
          this.map = null;
        }
        this.markerClusterGroup = null;
        this.leafletMarkers = [];
        this.markers = [];
        this.mapInitialized = false;
        this.mapInitStarted = false;
      } catch (e) {
        console.error(e);
      }
    },

    addMarkers() {
      try {
        this.clearAllMarkers();

        if (!this.data_list || !this.data_list.length) return;
        if (!this.map || !this.markerClusterGroup) return;

        this.data_list.forEach((item, index) => {
          try {
            if (!item.lat || !item.lng) return;

            const circleMarker = L.circleMarker(
              [parseFloat(item.lat), parseFloat(item.lng)],
              {
                radius: 8,
                fillColor: "#2196F3",
                color: "#fff",
                weight: 2,
                opacity: 1,
                fillOpacity: 0.8,
              },
            );

            const popupContent = document.createElement("div");
            popupContent.className = "marker-popup";
            popupContent.style.cursor = "pointer";
            popupContent.innerHTML = `
              <img src="${
                item.avatar || ""
              }" style="width: 100px; height: 100px; object-fit: cover;">
              <div class="marker-popup-content">
                <h4>${item.title || ""}</h4>
                <p>آدرس: ${item.address || ""}</p>
                <p>${item.contact || ""}</p>
              </div>
            `;
            popupContent.addEventListener("click", () =>
              this.showPost(this.data_list[index]),
            );
            circleMarker.bindPopup(popupContent, {
              maxWidth: 300,
              className: "custom-popup",
              offset: [0, -10],
            });

            this.markerClusterGroup.addLayer(circleMarker);
            const markerData = { marker: circleMarker, index };
            this.leafletMarkers.push(markerData);
            this.markers.push(markerData);
          } catch (err) {
            console.error("Error adding marker:", err);
          }
        });
      } catch (err) {
        console.error("addMarkers error:", err);
      }
    },

    clearAllMarkers() {
      try {
        if (this.markerClusterGroup) {
          try {
            this.markerClusterGroup.clearLayers();
          } catch (err) {
            console.error("Error clearing markerClusterGroup:", err);
          }
        }
        this.leafletMarkers.forEach((m) => {
          try {
            if (m.marker && this.map)
              this.map.removeLayer(m.marker);
          } catch (err) {
            console.error("Error removing marker:", err);
          }
        });
        this.leafletMarkers = [];
        this.markers = [];
      } catch (err) {
        console.error("clearAllMarkers error:", err);
      }
    },

    updateCircle() {
      try {
        if (!this.map) return;
        const centerObj = this.mapGetCenter();
        if (!centerObj) return;
        const radiusMeters = this.calculateViewportRadius();

        if (this.markerClusterGroup) {
          try {
            this.markerClusterGroup.bringToFront();
          } catch (err) {
            console.error("Error bringing clusters to front:", err);
          }
        }

        this.filteredProperties = this.getPropertiesWithinCircle(
          this.data_list,
          { latitude: centerObj.lat, longitude: centerObj.lng },
          radiusMeters,
        );
      } catch (err) {
        console.error("updateCircle error:", err);
      }
    },

    calculateViewportRadius() {
      if (!this.map) return 0;
      try {
        const center = this.map.getCenter();
        const bounds = this.map.getBounds();
        const ne = bounds.getNorthEast();
        return center.distanceTo(ne);
      } catch (e) {
        return 0;
      }
    },

    getPropertiesWithinCircle(list, centerCoordinates, radius) {
      try {
        if (!list || !centerCoordinates || isNaN(radius)) return [];
        const propertiesInCircle = [];
        const [centerLng, centerLat] = [
          centerCoordinates.longitude,
          centerCoordinates.latitude,
        ];
        list.forEach((property) => {
          try {
            if (property.lat && property.lng) {
              const propertyLng = parseFloat(property.lng);
              const propertyLat = parseFloat(property.lat);
              const distance = this.calculateDistance(
                centerLat,
                centerLng,
                propertyLat,
                propertyLng,
              );
              if (distance <= radius / 1000) propertiesInCircle.push(property);
            }
          } catch (err) {
            console.error("getPropertiesWithinCircle iteration error:", err);
          }
        });
        return propertiesInCircle;
      } catch (err) {
        console.error("getPropertiesWithinCircle error:", err);
        return [];
      }
    },

    calculateDistance(lat1, lng1, lat2, lng2) {
      try {
        if (isNaN(lat1) || isNaN(lng1) || isNaN(lat2) || isNaN(lng2))
          return Infinity;
        const R = 6371;
        const dLat = this.degreesToRadians(lat2 - lat1);
        const dLng = this.degreesToRadians(lng2 - lng1);
        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(this.degreesToRadians(lat1)) *
            Math.cos(this.degreesToRadians(lat2)) *
            Math.sin(dLng / 2) *
            Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
      } catch (err) {
        console.error("calculateDistance error:", err);
        return Infinity;
      }
    },

    degreesToRadians(deg) {
      return deg * (Math.PI / 180);
    },

    debounce(fn, wait) {
      let timeout = null;
      return (...args) => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          timeout = null;
          try {
            fn.apply(this, args);
          } catch (err) {
            console.error("debounced function error:", err);
          }
        }, wait);
      };
    },

    onMapChanged() {
      try {
        const centerObj = this.mapGetCenter();
        if (!centerObj) return;
        const radiusMeters = this.calculateViewportRadius();
        const radiusKm = radiusMeters / 1000;

        const prev = this.lastRequestedCenter;
        let shouldRequest = true;
        if (prev && this.lastRequestedRadiusKm != null) {
          const movedKm = this.calculateDistance(
            prev.lat,
            prev.lng,
            centerObj.lat,
            centerObj.lng,
          );
          const radiusChangeRatio =
            Math.abs(radiusKm - this.lastRequestedRadiusKm) /
            (this.lastRequestedRadiusKm || 1);
          if (
            movedKm < this.moveDistanceThresholdKm &&
            radiusChangeRatio < this.radiusChangeThresholdRatio
          ) {
            shouldRequest = false;
          }
        }

        this.updateCircle();

        if (shouldRequest) {
          this.dataPendingCenter = { lat: centerObj.lat, lng: centerObj.lng };
          this.dataPendingRadiusKm = radiusKm;
          if (this.debouncedMapRequest) this.debouncedMapRequest();
        }
      } catch (err) {
        console.error("onMapChanged error:", err);
      }
    },

    async requestDataForMap() {
      try {
        if (!this.dataPendingCenter || this.dataPendingRadiusKm == null) return;
        const center = this.dataPendingCenter;
        const radiusKm = this.dataPendingRadiusKm;

        try {
          if (this.currentRequestSource) {
            try {
              this.currentRequestSource.cancel("canceled by new request");
            } catch (innerErr) {
              console.error("Error canceling previous axios token:", innerErr);
            }
          }
        } catch (err) {
          console.error("Error during cancel previous request check:", err);
        }

        let cancelSource = null;
        if (axios.CancelToken) {
          cancelSource = axios.CancelToken.source();
          this.currentRequestSource = cancelSource;
        } else {
          this.currentRequestSource = null;
        }

        const payload = { ...this.fillter };
        payload.center_lat = center.lat;
        payload.center_lng = center.lng;
        payload.radius_km = radiusKm;
        payload.page = 1;
        payload.per_page = this.fillter.per_page || "get";
        payload.view_mode = "map";
        if (this.$store.state.auth && this.$store.state.auth.loggedIn)
          payload.user_id = this.$store.state.auth.uid;

        this.isLoading = true;

        const axiosOptions = {};
        if (cancelSource) axiosOptions.cancelToken = cancelSource.token;

        const response = await axios.post(
          this.$store.getters.baseUrl + "/branch-list-all",
          payload,
          axiosOptions,
        );

        if (
          response.data &&
          (response.data.result === 1 || response.data.result === "1")
        ) {
          this.data_list =
            response.data.list && response.data.list.list
              ? response.data.list.list
              : response.data.list || [];
          if (this.map) {
            this.addMarkers();
            this.updateCircle();
          }
          this.lastRequestedCenter = { lat: center.lat, lng: center.lng };
          this.lastRequestedRadiusKm = radiusKm;
        } else {
          this.data_list = [];
          this.clearAllMarkers();
        }
      } catch (err) {
        if (!(axios.isCancel && axios.isCancel(err))) {
          console.error("Error fetching branch list for map:", err);
        }
      } finally {
        this.isLoading = false;
        this.currentRequestSource = null;
      }
    },

    selectSlide(index) {
      try {
        this.fillter.cid = index;
        const center = this.mapGetCenter();
        if (center) {
          this.dataPendingCenter = center;
          this.dataPendingRadiusKm = this.calculateViewportRadius() / 1000;
          this.requestDataForMap();
        } else {
          this.load_post();
        }
      } catch (err) {
        console.error("selectSlide error:", err);
      }
    },

    async load_category() {
      try {
        const r = await axios.get(
          this.$store.getters.baseUrl + "/branch-cat-list",
        );
        this.category_list = r.data.list || [];
      } catch (err) {
        console.error("load_category error:", err);
      }
    },

    showPost(user) {
      try {
        const bid = user.id;
        this.$router.push({ path: "/profile-amlak", query: { bid } });
      } catch (err) {
        console.error("showPost error:", err);
      }
    },

    async load_post() {
      try {
        const response = await axios.post(
          this.$store.getters.baseUrl + "/branch-list-all",
          this.fillter,
        );
        if (response.data && response.data.result == 1) {
          this.data_list =
            response.data.list && response.data.list.list
              ? response.data.list.list
              : response.data.list || [];
          if (this.map) {
            this.addMarkers();
            this.updateCircle();
          }
        }
      } catch (err) {
        console.error("load_post error:", err);
      }
    },

    OpenMenu() {
      this.$router.push({
        query: {
          ...this.$route.query,
          ["branches"]: "active",
        },
      });
      this.showList = true;
      const el = document.querySelector(".AllShowMapToUSer");
      if (el) el.style.zIndex = "999999999";
    },
    closeBtn() {
      history.back();
      this.showList = false;
      const el = document.querySelector(".AllShowMapToUSer");
      if (el) el.style.zIndex = "300";
    },

    checkWindowSize() {
      this.windowWidth = window.innerWidth;
    },
  },

  created() {
    this.debouncedMapRequest = this.debounce(
      () => this.requestDataForMap(),
      this.moveDebounceMs,
    );
  },

  mounted() {
    try {
      this.publicPath =
        this.$store?.state?.c_set?.public_path || this.publicPath || "";

      this.load_category();

      window.addEventListener("resize", this.checkWindowSize);
      this.checkWindowSize();

      this.popupClickHandler = (event) => {
        try {
          this.showPost(event.detail);
        } catch (err) {
          console.error("popupClickHandler error:", err);
        }
      };
      document.addEventListener("showPostFromPopup", this.popupClickHandler);
    } catch (err) {
      console.error("mounted error:", err);
    }
  },

  beforeUnmount() {
    this.destroyMap();

    try {
      if (this.currentRequestSource && this.currentRequestSource.cancel) {
        this.currentRequestSource.cancel("component unmount");
      }
    } catch (err) {
      console.error("Error canceling currentRequestSource in unmount:", err);
    }

    try {
      document.removeEventListener("showPostFromPopup", this.popupClickHandler);
    } catch (err) {
      console.error("Error removing showPostFromPopup listener:", err);
    }
    try {
      window.removeEventListener("resize", this.checkWindowSize);
    } catch (err) {
      console.error("Error removing window listeners in unmount:", err);
    }
  },
};
</script>

<style lang="scss" scoped>
.classShowApartmentSow {
  display: grid;
  grid-template-columns: 55% 40%;
  justify-content: space-between;
  min-height: 100px;
}

.classShowApartmentSow {
  margin-top: 0 !important;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 0.375rem;
  border: 1px solid rgb(209, 213, 219);
  background: #fff !important;
  box-shadow: 0 1px 2px 0 rgb(0, 0, 0, 0.1);
}
.classShowApartmentSow img {
  height: 130px;
}
.classShowApartmentSow h1 {
  white-space: inherit !important;
}

.MapLeftAllShowMapToUSer {
  position: relative;
}

.mapFilters {
  position: absolute;
  z-index: 401;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 90%;
  max-width: 546px;
  padding-top: 42px;

  .mepSearchFilter {
    position: relative;
    height: 42px;
    width: 100%;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
    padding-right: 12px;

    input {
      width: 90%;
      height: 100%;
      padding: 0 2%;
      background: transparent;
      font-size: 1rem;

      &::placeholder {
        opacity: 1;
        color: #9ca3af;
      }
    }

    .searchBtn {
      position: absolute;
      left: 0;
      top: 9px;
      margin-left: 12px;
      margin-top: 4px;
      font-size: 1.15rem;
      cursor: pointer;
    }
  }
}

.swiperFilterList {
  display: block;
  width: 100%;
  max-width: 546px;
  margin: 0 auto;
  margin-top: 12px;

  .swiper {
    .swiper-slide {
      width: auto;
    }
  }

  .filterThumb {
    height: 40px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #e1e1e1;
    cursor: pointer;

    &.selected {
      border: 1px solid #0096c7;
      background: #0096c7;
      color: #fff;
    }
  }
}

@media (min-width: 1100px) {
  .TopShowBackToPage {
    display: none !important;
  }
}

@media (max-width: 1100px) {
  .mapFilters {
    padding-top: 30px;
  }

  .ChildShowTabToUserCustomer.sliderBottm.listSkeletor {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
}

:deep(.custom-cluster-marker) {
  background: rgba(255, 255, 255, 0.8);
  border: 2px solid #0096c7;
  border-radius: 5px;
  color: #000;
  height: 28px !important;
  width: 50px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "iranyekanB";

  div {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  span {
    font-size: 13px;
  }
}

@media (max-width: 1100px) {
  .TopShowBackToPage {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25) !important;
  }
}
</style>
